var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__C_Section",class:[_vm.currentMarginBottom],style:({ 'margin-bottom': _vm.currentMarginBottomStyle })},[_vm._t("default"),(_vm.separate)?_c('CSeparator',{attrs:{"spaced":""}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }